import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { AdjudicationParadigm } from "./models";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// True when the logged-in user is the adjudicator on a FORCED-paradigm case. A Forced adjudicator
// selects a winning read and has no read of their own, so Mark as Scored and accepting AI do not
// apply to them (the backend rejects both). Adjudication reads come back blinded only for the
// case's adjudicator.
export const useIsForcedAdjudicator = (): boolean =>
  useAppSelector(state => {
    const study = "resource" in state.studies.study ? state.studies.study.resource.study : null;
    const reads = state.caseImageViewer.adjudicationReads;
    return (
      study?.adjudicationParadigm === AdjudicationParadigm.Forced && reads !== null && reads.blinded
    );
  });
